import $ from 'jquery'

export default class {
  constructor(params) {
    this.container = $('<div/>')
      .attr('id', 'remote_form_message')
      .addClass('modal')
      .append(
        $('<div/>')
          .addClass('modal-dialog')
          .append(
            $('<div/>')
              .addClass('modal-content')
              .append(
                $('<div/>')
                  .addClass('modal-header')
                  .append($('<div/>').addClass('modal-title'))
              )
          )
      )
      .appendTo('body')

    params = params || {}
    this.life_time = params.life_time || 4000
    this.error_class = params.error_class || 'error'
    this.container_error_class = params.container_error_class || 'field-error'
    this.error_desc = params.error_desc || 'error_desc'

    $('.JS-Ajax-form')
      .on('submit', (e) => this.submit($(e.target)))
      .on('ajax:success', (e, data) => this.success(data, $(e.target)))
      .on('ajax:error', (e, xhr) => this.error(xhr.responseJSON.error, $(e.target)))
  }

  _alert(message) {
    this.container.find('.modal-title').html(message)
    this.container.modal('show')

    setTimeout(() => this.container.modal('hide'), this.life_time)
  }

  error(errors, $form) {
    let objName = $form.data('name')
    $.each(errors, (fieldName, fieldErrors) => {
      let $field = $("[name='" + objName + '[' + fieldName + "]']")
      if ($field.length) {
        $field.addClass(this.error_class)
        $field.parent().addClass(this.container_error_class)
        $.each(fieldErrors, (i, errorCaption) => {
          $field.after(
            $('<div/>')
              .addClass(this.error_desc)
              .text(errorCaption)
          )
        })
      }
    })
  }

  submit($form) {
    $form.find('.' + this.error_class).removeClass(this.error_class)
    $form.find('.' + this.container_error_class).removeClass(this.container_error_class)
    $form.find('.' + this.error_desc).remove()
  }

  success(data, $form) {
    $form.find('textarea, input:not([type=submit])').val('')
    let $modalParent = $form.parents('.modal')
    if ($modalParent.length) $modalParent.modal('hide')
    if (data.redirect) window.location = data.redirect
    if (data.message && data.message.length) this._alert(data.message)
  }
}
